export default __webpack_public_path__ + "static/media/4.62d3a6de.jpg";